export const authMixin =  {

    data(){
        return {
            askToDiscard: false
        }
    },

    methods: {

        fn_getTrueCallerUser: function(){
            let self = this;
            this.getData('GetTrueCallerUser', null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        let trueCallerUser = JSON.parse(response);
                        if(trueCallerUser){
                            self.fn_getTrueCallerProfile();    
                        }
                        else{
                            self.fn_getPhoneNumber();
                        }
                        
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_getTrueCallerProfile: function(){
            let self = this;
            this.getData('GetTrueCallerProfile', null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        self.fn_formatProfileData(response);
                    }, 
                    onError: function(error){   
                        console.log(error);
                    }
                }
            );
        },

        // fn_formatProfileData: function(response){
        //     let userProfile = JSON.parse(response);
        //     let tokenObj = {};
        //     tokenObj.Payload = userProfile.Payload;
        //     tokenObj.Signature = userProfile.Signature;
        //     tokenObj.accessToken = userProfile.accessToken;
        //     let mobileNumber = userProfile.PhoneNumber;
        //     this.fn_getCustomToken(tokenObj, mobileNumber);
        // },

        // fn_getCustomToken: function(dataObj, mobileNumber){
        //     if(!navigator.onLine){
        //         this.showToast('Internet not available');
        //         this.hideLoading();
        //         return;
        //     }

        //     let self = this;
        //     this.showLoading('Please wait...');
        //     this.postServerData('GetCustomToken', dataObj, 
        //         {
        //             onSuccess: function(response){
        //                 console.log(response);
        //                 let tokenData = JSON.parse(response);
        //                 self.fn_signInUsingToken(tokenData.Token, mobileNumber);
        //             }, 
        //             onError: function(error){
        //                 console.log(error);
        //                 self.hideLoading();
        //             }
        //         }
        //     );
        // },

        // fn_signInUsingToken: function(token, mobileNumber, failureCallback){
        //     if(!navigator.onLine){
        //         this.showToast('Internet not available');
        //         this.hideLoading();
        //         return;
        //     }

        //     let self = this;
        //     this.getData('SignInUsingToken', token, 
        //         {
        //             onSuccess: function(response){
        //                 console.log(response);
        //                 self.hideLoading();
        //                 self.fn_getToken(null, mobileNumber, failureCallback);
        //             }, 
        //             onError: function(error){
        //                 self.hideLoading();
        //                 console.log(error);
        //             }
        //         }
        //     );
        // },

        fn_getPhoneNumber: function(){
            let self = this;
            this.showLoading("Please wait...");
            this.$root.fn_getAuthToken(function(token){
                self.$root.fn_getPhoneNumber(token, function(mobileNumber){
                    self.hideLoading();
                    self.fn_getOtp(mobileNumber);
                })
            })
        },

        // fn_verifyTrueCallerByNumber: function(mobileNumber){
        //     if(!navigator.onLine){
        //         this.showToast('Internet not available');
        //         return;
        //     }

        //     this.$refs['ref_dialogMissCall'].openDialogWeb();

        //     let self = this;
        //     this.getData('VerifyTrueCallerByNumber', mobileNumber, 
        //         {
        //             onSuccess: function(response){
        //                 console.log(response);
        //                 self.fn_formatProfileData(response);
        //                 self.$refs['ref_dialogMissCall'].closeDialogWeb();
        //             }, 
        //             onError: function(error){
        //                 console.log(error);
        //                 self.$refs['ref_dialogMissCall'].closeDialogWeb();
        //                 self.showToast('Verification via call failed! Please verify through OTP.');
        //                 setTimeout(function(){
        //                     self.fn_getOtp(mobileNumber);
        //                 },300);
        //             }
        //         }
        //     );
        // },

    }
}


// WEBPACK FOOTER //
// ./src/components/settings/auth_mixin.js